module.exports = __webpack_public_path__ + "static/logo-caac40ca63bf54944c0d02a6a489dd75.png";